import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { useState } from 'react';
import {ErrorMessage } from 'formik'
import { ErrorMsg } from '../components/common/ErrorMsg';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
      display: 'flex',
      alignItems: 'center'
    },
    input: {
      display: 'none',
    },
    filename: {
        color: '#333',
        maxWidth: '300px',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        cursor: 'default',
    }
  }));

const FileField = ({ field, form }) => {
    const {name} = field
    const [label, setLabel] = useState('')

    const classes = useStyles();

    const handleChangeFile = e => {
        setLabel(e.target.files[0].name);
        form.setFieldValue(name, e.currentTarget.files[0])
    }

    return (
        <>
          <div className={classes.root}>
          <input
              onChange={handleChangeFile}
              accept="image/*"
              className={classes.input}
              id="contained-button-file"
              type="file"
          />
          <label htmlFor="contained-button-file">
              <Button variant="contained" color="primary" component="span">
              Upload
              </Button>
          </label>
          <span title={label} className={classes.filename}>{label}</span>
          </div>
          <ErrorMessage name={name} component={ErrorMsg}/>
        </>
    )
}

export default FileField
